module.exports = "/wwwroot/img/anchor_links_block.png?ver=2decebea";